/* Delegated handlers also work after Shopify theme-editor section reloads. */
document.addEventListener('click', (event) => {
 const button = event.target.closest('[data-sr-scroll]');
 if (!button) return;
 const track = document.getElementById(button.getAttribute('aria-controls'));
 if (!track) return;
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 track.scrollBy({left: Number(button.dataset.srScroll) * Math.max(200, track.clientWidth * .8), behavior: reduced ? 'auto' : 'smooth'});
});
document.addEventListener('shopify:block:select', (event) => {
 const card = event.target.closest('.sr-bike-card');
 if (card) card.scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});
});

document.addEventListener('click', (event) => {
 const button = event.target.closest('[data-sr-marquee-toggle]');
 if (!button) return;
 const track = document.getElementById(button.getAttribute('aria-controls'));
 if (!track) return;
 const paused = button.getAttribute('aria-pressed') !== 'true';
 track.style.animationPlayState = paused ? 'paused' : 'running';
 button.setAttribute('aria-pressed', String(paused));
 button.setAttribute('aria-label', paused ? 'Resume moving logos' : 'Pause moving logos');
 button.textContent = paused ? 'Resume' : 'Pause';
});
